<template>
  <div>
    <mdb-modal
      scrollable
      removeBackdrop
      centered
      @close="$store.commit('clearCurrentModal')"
      elegant
    >
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue"
          >Register for Test Studio Finder</mdb-modal-title
        >
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          Please provide your information to create an account and access all
          Teststudios.
        </p>
        <form v-on:submit.prevent v-on:keyup.enter="registerUser">
          <div class="grey-text">
            <mdb-input label="Your name" v-model="name" outline />
            <mdb-input label="Company name" v-model="company" outline />
            <mdb-input label="Email address" v-model="email" outline />
            <mdb-input label="Phone number" v-model="phone" outline />
            <mdb-select
              v-model="mdbTypeOfCompany"
              label="What type of company do you work in ?"
              outline
            />
            <mdb-input
              v-model="typeOfCompanyOtherText"
              v-show="typeOfCompany == 7"
              label="Please describe type of company"
              type="text"
              outline
            ></mdb-input>
            <mdb-select
              v-model="mdbRoleInCompany"
              label="Please describe your role in the company"
              outline
            />
            <mdb-input
              v-model="roleInCompanyOtherText"
              v-show="roleInCompany == 7"
              label="Please describe your role in the company"
              type="text"
              outline
            ></mdb-input>
            <mdb-select
              v-model="mdbRef"
              label="How did your find out about the Test Studio Finder?"
              outline
            />
            <mdb-input
              v-model="refOtherText"
              v-show="ref == 7"
              label="Please describe how you found this service"
              type="text"
              outline
            ></mdb-input>
            <mdb-input
              label="Your password"
              type="password"
              v-model="password"
              outline
            />
            <mdb-input
              label="Re-type password"
              type="password"
              v-model="passwordRetyped"
              outline
            />
          </div>
          <validation-info :text="validationInfo" />
          <div class="text-center">
            <mdb-btn
              :disabled="dataLoading"
              class="btn btn-isi"
              @click="registerUser"
              >Create account now</mdb-btn
            >
          </div>
        </form>
      </mdb-modal-body>
      <mdb-modal-footer class="mx-5 d-flex justify-content-center" end>
        Already have an account?
        <a
          class="link"
          @click="$store.commit('setCurrentModal', { type: 'loginModal' })"
          >Click here to login.</a
        >
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import ValidationInfo from "../ValidationInfo.vue";

export default {
  components: {
    ValidationInfo,
  },
  created() {
    window.gtag("event", "open_register_dialog", {
      event_category: "registration",
    });
    for (let key in this.$store.state.registrationFormInfo.items) {
      for (let el of this.$store.state.registrationFormInfo.items[key]) {
        let text = el[1];
        let value = el[0];
        this["mdb" + key[0].toUpperCase() + key.substring(1)].push({
          text: text,
          value: value,
          selected: false,
        });
      }
    }
  },
  data() {
    return {
      dataLoading: false,
      name: "",
      company: "",
      email: "",
      phone: "",
      mdbTypeOfCompany: [],
      typeOfCompanyOtherText: "",
      mdbRoleInCompany: [],
      roleInCompanyOtherText: "",
      mdbRef: [],
      refOtherText: "",
      password: "",
      passwordRetyped: "",
      validationInfo: "",
    };
  },
  computed: {
    typeOfCompany() {
      let x = this.mdbTypeOfCompany.find((x) => x.selected);
      if (x && x.value) {
        return parseInt(x.value);
      } else {
        return null;
      }
    },
    roleInCompany() {
      let x = this.mdbRoleInCompany.find((x) => x.selected);
      if (x && x.value) {
        return parseInt(x.value);
      } else {
        return null;
      }
    },
    ref() {
      let x = this.mdbRef.find((x) => x.selected);
      if (x && x.value) {
        return parseInt(x.value);
      } else {
        return null;
      }
    },
  },
  methods: {
    registerUser() {
      if (!this.name) {
        this.validationInfo = "Please enter your name.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "name",
        });
        return;
      }
      if (!this.company) {
        this.validationInfo = "Please enter the name of your company.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "company",
        });
        return;
      }
      // simple check for frontend
      if (!/\S+@\S+\.\S+/.test(this.email)) {
        this.validationInfo = "Please provide a valid email address.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "email",
        });
        return;
      }
      if (!this.phone) {
        this.validationInfo = "Please enter your phone number.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "phone",
        });
        return;
      }
      if (!this.typeOfCompany) {
        this.validationInfo = "Please enter the type of your company.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "type_of_company",
        });
        return;
      } else if (this.typeOfCompany == 7 && !this.typeOfCompanyOtherText) {
        this.validationInfo = "Please describe the type of your company.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "type_of_company_other",
        });
        return;
      }
      if (!this.roleInCompany) {
        this.validationInfo = "Please enter your role in the company.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "role_in_company",
        });
        return;
      } else if (this.roleInCompany == 7 && !this.roleInCompanyOtherText) {
        this.validationInfo = "Please describe your role in the company.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "role_in_company_other",
        });
        return;
      }
      if (!this.ref) {
        this.validationInfo =
          "Please enter how you found out about the Test Studio Finder.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "ref",
        });
        return;
      } else if (this.ref == 7 && !this.refOtherText) {
        this.validationInfo = "Please describe how you found this service.";
        window.gtag("event", "registration_fail", {
          event_category: "registration",
          event_label: "ref_other",
        });
        return;
      }
      if (!this.password) {
        this.validationInfo = "Please type in your password.";
        return;
      }
      if (!this.passwordRetyped) {
        this.validationInfo = "Please re-type your password.";
        return;
      }
      if (this.password != this.passwordRetyped) {
        this.validationInfo = "The given passwords do not match.";
        return;
      }

      this.validationInfo = "";

      this.dataLoading = true;
      this.$http({
        method: "post",
        url: "/api/UserAction/Register",
        data: {
          name: this.name,
          email: this.email,
          company: this.company,
          phoneNumber: this.phone,
          typeOfCompany: parseInt(this.typeOfCompany),
          typeOfCompanyOtherText: this.typeOfCompanyOtherText,
          roleInCompany: this.roleInCompany,
          roleInCompanyOtherText: this.roleInCompanyOtherText,
          ref: this.ref,
          refOtherText: this.refOtherText,
          password: this.password,
        },
      })
        .then((rsp) => {
          if (rsp.data.err) {
            this.validationInfo = rsp.data.err;
            this.dataLoading = false;
            return;
          }
          window.gtag("event", "sign_up", {
            event_category: "registration",
            method: "manual",
          });
          this.$store.commit("setCurrentModal", {
            type: "generalInfoModal",
            options: {
              title: "Registration successful",
              content:
                "Please click the verification link we sent to you via email.",
            },
          });
          this.dataLoading = false;
        })
        .catch((err) => {
          this.dataLoading = false;
          if (typeof err.response.data == "string") {
            window.gtag("event", "registration_fail", {
              event_category: "registration",
              event_label: "backend",
            });
            this.validationInfo = err.response.data;
          } else {
            this.validationInfo = "An error occured during your registration.";
            window.gtag("event", "registration_fail", {
              event_category: "registration",
              event_label: "backend",
            });
          }
        });
    },
  },
};
</script>

<style>
.select-dropdown label {
  max-width: 400px;
}
</style>

<style scoped>
#footer-text {
  width: 100%;
  text-align: center;
}
</style>